// extracted by mini-css-extract-plugin
module.exports = {"content":"account-limit-reached_content__tvwfj","bodyText":"account-limit-reached_bodyText__F0L2R","link":"account-limit-reached_link__2w8Ad"};